import { useAuth } from "@/contexts/AuthContext";
import CompanyInvite from "@/components/company/CompanyInvite";
import TeamMembers from "@/components/company/TeamMembers";
import PageLayout from "@/components/layout/PageLayout";
import PageHeader from "@/components/layout/PageHeader";

const TeamPage = () => {
  const { isAdmin: isCompanyAdmin } = useAuth();

  const handleInvitationSent = () => {
    window.dispatchEvent(new CustomEvent('invitationSent'));
  };

  return (
    <PageLayout maxWidth="md">
      <PageHeader 
        title="Teams and Crews"
        description="Manage your company team members and invitations"
      />

      <div className="grid gap-6">
        <TeamMembers />
        {isCompanyAdmin && <CompanyInvite onInvitationSent={handleInvitationSent} />}
      </div>
    </PageLayout>
  );
};

export default TeamPage;
